import type { ReadOnlyOwaUserConfiguration } from 'owa-service/lib/ReadOnlyTypes';
import type { PeopleHubOptions } from '../models/peopleHubOptions';
import { Sorting } from '..';
import DisplayOrder from 'owa-people-types/lib/types/DisplayOrder';

export function parsePeopleHubOptions(userConfig: ReadOnlyOwaUserConfiguration): PeopleHubOptions {
    const peopleHubOptions = userConfig?.ViewStateConfiguration?.PeopleHubOptions;

    if (peopleHubOptions) {
        return JSON.parse(peopleHubOptions) as PeopleHubOptions;
    }

    // Migrate settings from legacy jsMVVM. This will happen if no React user options found.
    const displayOption = getDisplayOption(userConfig);
    const sortOption = getSortOption(userConfig);

    return displayOption && sortOption
        ? {
              displayOrder: displayOption,
              sorting: sortOption,
          }
        : undefined;
}

const getDisplayOption = (userConfig: ReadOnlyOwaUserConfiguration): number => {
    const legacyDisplayOption = userConfig?.ViewStateConfiguration?.PeopleHubDisplayOption;
    switch (legacyDisplayOption) {
        case 1:
            return DisplayOrder.FirstNameLastName;
        case 2:
            return DisplayOrder.LastNameFirstName;
        default:
            return DisplayOrder.FirstNameLastName;
    }
};

const getSortOption = (userConfig: ReadOnlyOwaUserConfiguration): number => {
    const legacySortOption = userConfig?.ViewStateConfiguration?.PeopleHubSortOption;
    switch (legacySortOption) {
        case 1:
            return Sorting.ByFirstName;
        case 2:
            return Sorting.ByLastName;
        case 3:
            return Sorting.ByCompany;
        case 4:
            return Sorting.ByHomeCity;
        case 5:
            return Sorting.ByWorkCity;
        case 6:
            return Sorting.ByRecentlyAdded;
        default:
            return Sorting.ByFirstName;
    }
};
